import { InjectionToken } from '@angular/core';

export type BooxSessionToken = {
    expired_soon: number;
    auto_logout: boolean;
    storage_key: string;
    [key: string]: any;
};

export const BOOX_SESSION = new InjectionToken<BooxSessionToken>('(lib-boox) BOOX_SESSION', {
    providedIn : 'root', factory: () => ({expired_soon: 300, auto_logout: true, storage_key: 'boox-session'})
});
